import { MY_WALLET_ROUTE } from '~/features/my-wallet/constants/my-wallet'

export function useWalletTabNavigation() {
  const route = useRoute()
  const router = useRouter()

  // Also called from the home, so the path is always the wallet; its own query is kept when already there.
  function goToTab(tab: string) {
    const currentQuery = route.path === MY_WALLET_ROUTE ? route.query : {}
    router.push({ path: MY_WALLET_ROUTE, query: { ...currentQuery, tab } })
  }

  return { goToTab }
}
